module.exports = __webpack_public_path__ + "static/media/icefields-28.d6099e08.jpg";